import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Button, Card, CardBody, Col, Container, Form, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { API_ASSIST, API_GRADE, API_USER } from "../../../redux/apiRoutes";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from 'uuid';
import DatePicker from 'react-datepicker';
import es from "date-fns/locale/es";

import FilterComponent from "../../common/filter";
import SweetAlert from "sweetalert2";

const Assists = () => {
  const user = useSelector((content) => content.User);
  const navigate = useNavigate();
  
  const [modal, setModal] = useState(false);
  const toggle = () => {setModal(!modal);  reset(); setEditingAssist(false); clearModal();};

  const clearModal = () => {
    setStudentSelected([]);
    setGradeSelected([]);
    setdataStudents([]);
    setDate(new Date());
    setHomeworkAssignation('');
  }

  const [studentSelected,setStudentSelected] = useState([]);
  const [dataStudents,setdataStudents] = useState([]);
  const getStudentsList = async (grade) => {
    console.log('=== getStudentsList ejecutándose ===');
    console.log('Grado seleccionado:', grade);
    console.log('Fecha actual:', date);
    
    await axios.get(`${API_USER}?status=ACTIVE&role=STUDENT&grade=${grade[0].uuid}&checkAssist=true`).then(response => {
      if(response.data.docs.length>0){
        const students = [];
        response.data.docs.map(student=>{
          const addStudent = {
            uuid: student.uuid,
            name: student.names + ' ' + student.second_names,
            grade: student.grade,
            assist: student.assist,
          }
          students.push(addStudent);
        });
        
        console.log('Estudiantes obtenidos:', students);
        setdataStudents(students);
        
        // Obtener ausencias reportadas para aplicar a la lista
        console.log('Estructura completa del grado:', grade[0]);
        console.log('Llamando getReportedAbsencesForStudents con:', {
          gradeName: grade[0].name,
          level: grade[0].level,
          date: date
        });
        // Extraer grado y nivel del nombre del grado (formato: "5to - PRIMARIA")
        const gradeName = grade[0].name.split(' - ')[0]; // "5to"
        const level = grade[0].name.split(' - ')[1]; // "PRIMARIA"
        
        console.log('Valores extraídos:', { gradeName, level });
        
        getReportedAbsencesForStudents(students, gradeName, level, date);
      }
    }).catch(e => {
      toast.error("No se pudo obtener el listado de Estudiantes: " + e.message, {position: 'bottom-right', style:{color:'white'}});
    });
  }

  const getReportedAbsencesForStudents = async (students, gradeName, level, selectedDate) => {
    try {
      // Usar la fecha seleccionada en el modal, no la fecha de hoy
      const dateString = selectedDate.toISOString().split('T')[0]; // Formato YYYY-MM-DD
      
      console.log(`Buscando ausencias para: grade=${gradeName}, level=${level}, date=${dateString}`);
      
      const response = await axios.get(`${API_ASSIST}/reported-absences?grade=${gradeName}&level=${level}&date=${dateString}`);
      
      console.log('Respuesta de ausencias reportadas:', response.data);
      
      if (response.data && response.data.reportedAbsences) {
        const reportedAbsences = response.data.reportedAbsences;
        
        console.log(`Encontradas ${reportedAbsences.length} ausencias reportadas`);
        
        // Aplicar ausencias reportadas a la lista de estudiantes
        const updatedStudents = students.map(student => {
          console.log(`Evaluando estudiante: "${student.name}"`);
          
          const reportedAbsence = reportedAbsences.find(absence => {
            console.log(`Comparando UUIDs: estudiante="${student.uuid}" vs ausencia="${absence.studentUuid}"`);
            const match = absence.studentUuid === student.uuid;
            console.log(`¿Coinciden los UUIDs? ${match}`);
            return match;
          });

          if (reportedAbsence) {
            console.log(`✅ APLICANDO ausencia a ${student.name}:`, reportedAbsence);
            return {
              ...student,
              assist: false,
              absenceReason: reportedAbsence.description || getAbsenceTypeDescription(reportedAbsence.type),
              absenceType: reportedAbsence.type,
              reportedByParent: true
            };
          } else {
            console.log(`❌ NO se aplicó ausencia a ${student.name}`);
          }

          return student;
        });
        
        setdataStudents(updatedStudents);
      }
    } catch (error) {
      console.error("Error getting reported absences:", error);
      // Si hay error, mantener la lista original
    }
  }

  const getAbsenceTypeDescription = (type) => {
    const descriptions = {
      'HEALTH': 'Enfermedad',
      'COMPETITION': 'Competencia',
      'VACATION': 'Vacaciones',
      'PERSONAL': 'Asunto personal'
    };
    return descriptions[type] || 'Ausencia reportada';
  }

  const handleAssistChange = (value, studentUuid) => {
    const students = [];
    dataStudents.map(student=>{
      if(student.uuid===studentUuid){
        // Prevenir cambio si el estudiante tiene ausencia reportada por padre
        if(student.reportedByParent && !student.assist){
          toast.warning("No se puede cambiar la asistencia de un estudiante con ausencia reportada por el padre", {position: 'bottom-right'});
          return; // No hacer el cambio
        }
        
        if(value){
          student.assist = true;
        }else{
          student.assist = false;
        }
      }
      students.push(student);
    });
    setdataStudents(students);
  }

  const checkExistingAttendanceList = async (grade, selectedDate) => {
    try {
      const dateString = selectedDate.toISOString().split('T')[0]; // Formato YYYY-MM-DD
      const gradeName = grade[0].name.split(' - ')[0]; // "6to"
      const level = grade[0].name.split(' - ')[1]; // "PRIMARIA"
      
      console.log(`Verificando lista existente: grade=${gradeName}, level=${level}, date=${dateString}`);
      
      const response = await axios.get(`${API_ASSIST}/check-existing?grade=${gradeName}&level=${level}&date=${dateString}`);
      
      console.log('Respuesta de verificación:', response.data);
      
      if (response.data && response.data.exists && response.data.attendanceList) {
        const existingList = response.data.attendanceList;
        console.log('Lista existente encontrada:', existingList);
        toast.error(`Ya existe un listado de asistencia para ${gradeName} ${level} tomado por ${existingList.creatorName} para la fecha: ${dateString}`, {
          position: 'bottom-right', 
          style: {color: 'white'}
        });
        return true; // Ya existe
      }
      console.log('No se encontró lista existente');
      return false; // No existe
    } catch (error) {
      console.error("Error checking existing attendance list:", error);
      return false;
    }
  }

  const handleGradeSelection = async (grade) => {
    setGradeSelected(grade);
    if(grade.length > 0) {
      // Verificar si ya existe una lista para esta fecha antes de cargar estudiantes
      const dateExists = await checkExistingAttendanceList(grade, date);
      if (!dateExists) {
        getStudentsList(grade);
      } else {
        // Solo limpiar los estudiantes, mantener el grado seleccionado
        setdataStudents([]);
      }
    }
  }

  const [gradeSelected,setGradeSelected] = useState([]);
  const [dataGrades,setdataGrades] = useState([]);
  const getGradesList = async () => {
    await axios.get(`${API_GRADE}?status=ACTIVE`).then(response => {
      if(response.data.docs.length>0){
        const grades = []
        response.data.docs.map(grade=>{
          const addGrade = {
            uuid: grade.uuid,
            name: grade.name + ' - ' + grade.level 
          }
          grades.push(addGrade);
        });
        setdataGrades(grades);
      }
    }).catch(e => {
      toast.error("No se pudo obtener el listado de Grados Escolares: " + e.message, {position: 'bottom-right', style:{color:'white'}});
    });
  }

  const [dataAssistList, setDataAssistList] = useState([]);
  const [isGetAssistList, setIsGetAssistList] = useState(false);
  const [editPermissions, setEditPermissions] = useState(false);
  const getAssistList = async () => {
    setIsGetAssistList(true);

    let queryRule = '';
    if(user.role==='ADMIN' || user.role==='SISTEMAS' || user.role === "COORDINADOR_GENERAL"){
      setEditPermissions(true);
      queryRule = `status=TAKED`;
    }

    if(user.role === "COORDINADOR_PREESCOLAR"){
      setEditPermissions(true);
      queryRule = `status=TAKED&level=PREESCOLAR,MATERNAL`;
    }

    if(user.role === "COORDINADOR_PRIMARIA"){
      setEditPermissions(true);
      queryRule = `status=TAKED&level=PRIMARIA`;
    }

    if(user.role === "COORDINADOR_SECUNDARIA"){
      setEditPermissions(true);
      queryRule = `status=TAKED&level=SECUNDARIA`;
    }

    if(user.role === "COORDINADOR_PREPARATORIA"){
      setEditPermissions(true);
      queryRule = `status=TAKED&level=PREPARATORIA`;
    }

    if(user.role === "DOCENT"){
      //getTechGrades(user.uuid);
      setEditPermissions(true);
      queryRule = `status=TAKED&grade=PREPARATORIA`;
    }
    
    await axios.get(`${API_ASSIST}?${queryRule}`).then(response => {
      if(response.data.docs.length>0){
        setDataAssistList(response.data.docs);
      }else{
        setDataAssistList([]);
      }
      setIsGetAssistList(false);
    }).catch(e => {
      setIsGetAssistList(false);
      toast.error("No se pudo obtener el listado de Tareas: " + e.message, {position: 'bottom-right', style:{color:'white'}});
    });
  }

  const estado = (status) =>{
    switch(status){
      case 'TAKED':
        return <div><span className="badge badge-success">Tomada</span></div>;
      case 'DISABLED':
        return <div><span className="badge badge-warning">Desactivada</span></div>;
    }
  }

  const columns = [
    {
      name: "Fecha",
      selector: (row) => row.date.split('T')[0],
      sortable: true,
      center: true,
    },
    {
      name: "Salón",
      selector: (row) => row.grade,
      sortable: true,
      center: true,
    },
    {
      name: "Nivel",
      selector: (row) => row.level,
      sortable: true,
      center: true,
    },
    {
      name: "Estado",
      selector: (row) => estado(row.status),
      sortable: true,
      center: true,
    },
    {
      name: "Tomó Lista",
      selector: (row) => row.creatorName,
      sortable: true,
      center: true,
    },
    {
      name: "Ausencias Reportadas",
      selector: (row) => {
        if (row.list && Array.isArray(row.list)) {
          const reportedAbsences = row.list.filter(student => student.reportedByParent && !student.assist);
          if (reportedAbsences.length > 0) {
            return (
              <div className="text-center">
                <span className="badge bg-warning text-dark">
                  <i className="fa fa-exclamation-triangle me-1"></i>
                  {reportedAbsences.length}
                </span>
              </div>
            );
          }
        }
        return <span className="text-muted">-</span>;
      },
      sortable: false,
      center: true,
      width: '150px'
    },
    {
      name: "Acciones",
      selector: (row) => <div style={{padding:5}}>
                          <Button color="light" style={{width: 40, padding: 6, marginRight:5, fontSize: 14}} onClick={()=>{handleEditAction(row)}}><i className="fa fa-pencil"></i></Button>
                          <Button color="light" style={{width: 40, padding: 6, marginRight:5, fontSize: 14}} onClick={()=>{handleDeleteAction(row)}}><i className="fa fa-trash"></i></Button>
                        </div>,
      width: '160px'
    },
  ];

  const [homeworkAssignation, setHomeworkAssignation] = useState('');
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const [date, setDate] = useState(new Date());

  const handleChangeStart = async (date) => {
    console.log('=== handleChangeStart ejecutándose ===');
    console.log('Nueva fecha:', date);
    console.log('Grado seleccionado:', gradeSelected);
    
    setDate(date);
    
    // Si ya hay un grado seleccionado, verificar si ya existe una lista para la nueva fecha
    if (gradeSelected.length > 0) {
      console.log('Verificando si existe lista para la nueva fecha...');
      const dateExists = await checkExistingAttendanceList(gradeSelected, date);
      console.log('¿Existe lista?', dateExists);
      
      if (dateExists) {
        console.log('Ya existe lista, limpiando solo estudiantes');
        // Solo limpiar los estudiantes, mantener el grado seleccionado
        setdataStudents([]);
        return;
      } else {
        console.log('No hay conflicto, recargando estudiantes...');
        // Si no hay conflicto, recargar los estudiantes para la nueva fecha
        getStudentsList(gradeSelected);
      }
    } else {
      console.log('No hay grado seleccionado, no se hace nada');
    }
  };

  const [savingAssist, setSaveAssist] = useState(false);
  const saveAssist = async (data) => {
    setSaveAssist(true);
    if (data !== "") {
      if(gradeSelected.length<=0){
        toast.error("Indica el grupo al que tomarás lista", {position: 'bottom-right', style:{color:'white'}});
        setSaveAssist(false);
        return;
      }

      if(date==="" || date === null){
        toast.error("Ingresa la fecha de entrega", {position: 'bottom-right', style:{color:'white'}});
        setSaveAssist(false);
        return;
      }

      if(dataStudents.length===0){
        toast.error("No hay estudiantes para asignar a la lista", {position: 'bottom-right', style:{color:'white'}});
        setSaveAssist(false);
        return;
      }

      const dateFormat = date.toLocaleDateString().split("/");
      let dt = `${dateFormat[2]}-${dateFormat[1] < 10 ? `0${dateFormat[1]}` : dateFormat[1]}-${dateFormat[0] < 10 ? `0${dateFormat[0]}` : dateFormat[0]}`;
      data.date = dt;
      data.list = dataStudents;

      data.uuid = uuidv4();
      data.creatorUuid = user.uuid;
      data.gradeUuid = gradeSelected[0].uuid;
      data.level = gradeSelected[0].name.split(' - ')[1];
      data.grade = gradeSelected[0].name.split(' - ')[0];
      data.creatorName = user.name;
      data.status = 'TAKED';

      await axios.post(`${API_ASSIST}`,data).then(response => {
        if(response.data){
          toggle();
          getAssistList();
          reset();
          toast.success("¡Listado creado con éxito!", {position: 'bottom-right', style:{color:'white'}});
        }
        setSaveAssist(false);
      }).catch(e => {
        setSaveAssist(false);
        console.log(e)
        toast.error("No se pudo crear la lista de asistencia: " + e.request.response, {position: 'bottom-right', style:{color:'white'}});
      });
    } else {
      errors.showMessages();
    }
  };

  const [currentAssist, setCurrentAssist] = useState({});
  const handleEditAction = (assist) => {
    toggle();
    setEditingAssist(true);
    setCurrentAssist(assist);

    if(assist.gradeUuid!==undefined && assist.gradeUuid !== null){
      dataGrades.map((grade)=>{
        if(grade.uuid===assist.gradeUuid){
          setGradeSelected([grade]);
        }
      });
    }

    if(assist.list!==undefined && assist.list !== null){
      const students = []
      assist.list.map((student)=>{
        const addStudent = {
          uuid: student.uuid,
          name: student.name,
          grade: student.grade,
          assist: student.assist,
        }
        students.push(addStudent);
      });
      setdataStudents(students);
    }
    
    setTimeout(()=>{
      // Corregir problema de zona horaria al parsear la fecha
      const dateString = assist.date.split('T')[0]; // Obtener solo la parte de la fecha
      const [year, month, day] = dateString.split('-');
      setDate(new Date(year, month - 1, day)); // month - 1 porque los meses en JS van de 0-11
    },500)
  }

  const [isEditingAssist, setEditingAssist] = useState(false);
  const [patchingHomework, setPatchingHomework] = useState(false);
  const patchHomework = async (data) => {
    setPatchingHomework(true);

    if (data !== "") {
      if(gradeSelected.length<=0){
        toast.error("Indica el grupo al que tomarás lista", {position: 'bottom-right', style:{color:'white'}});
        setSaveAssist(false);
        return;
      }

      if(date==="" || date === null){
        toast.error("Ingresa la fecha de entrega", {position: 'bottom-right', style:{color:'white'}});
        setSaveAssist(false);
        return;
      }

      data.date = date;
      if(homeworkAssignation === 'GROUP'){ 
        data.gradeUuids = [gradeSelected[0].uuid];
        data.level = gradeSelected[0].name.split(' - ')[1];
        data.grade = gradeSelected[0].name.split(' - ')[0];
      }
  
      await axios.patch(`${API_ASSIST}/${currentAssist.uuid}`,data).then(response => {
        if(response.data){
          getAssistList();
          toggle();
          setPatchingHomework(false);
          toast.success("¡Tarea actualizar con éxito!", {position: 'bottom-right', style:{color:'white'}});
        }
        setPatchingHomework(false);
      }).catch(e => {
        setPatchingHomework(false);
        toast.error("No se pudo actualizar la tarea: " + e.message, {position: 'bottom-right', style:{color:'white'}});
      });
    } else {
      errors.showMessages();
    }
  }

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(
    false
  );

  const handleDeleteAction = (data) => {
    SweetAlert.fire({
      title: "¿Continuamos?",
      text: `Se eliminará la lista de asistencia del ${data.date.split("T")[0]} para ${data.grade} ${data.level}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        await axios.delete(`${API_ASSIST}/${data.uuid}`).then(response => {
          getAssistList();
          SweetAlert.fire("¡Listo!", "listado de asistencia eliminado", "success");
        }).catch(error => {
          setTimeout(() => {
            toast.error(
              "Error al eliminar el listado de asistencia: " + error
            );
          }, 200);
        });
      }
    });
  }

  const filteredItems = dataAssistList.filter(
    item =>
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(filterText.toLowerCase()) !== -1
  );

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={e => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    if(
      user.role !== 'ADMIN' 
      && user.role !== "SISTEMAS"
      && user.role !== "COORDINADOR_GENERAL"
      && user.role !== "COORDINADOR_PREESCOLAR"
      && user.role !== "COORDINADOR_PRIMARIA"
      && user.role !== "COORDINADOR_SECUNDARIA"
      && user.role !== "COORDINADOR_PREPARATORIA"
      && user.role !== "DOCENT"
    ){
      navigate('/inicio');
    }
    getGradesList();
    getAssistList();
  }, [navigate]);

  return (
    <Fragment>
      <Breadcrumb parent="Herramientas" title="Listas de Asistencias"/>
      {user.role !== 'TUTOR' ?
        <>
          <Container fluid={true}>
            <Row>
              <Col sm="12" style={{display:'flex', justifyContent:'flex-end', marginBottom: 20, paddingRight:30}}>
                <Button color="primary" onClick={toggle}>Tomar Nueva Lista</Button>
              </Col>
            </Row>

            <Row>
              <Col sm="12">
                <Card>
                  <CardBody className="data-tables">
                    <DataTable
                      columns={columns}
                      striped={true}
                      center={true}
                      data={filteredItems}
                      subHeader
                      pagination
                      subHeaderComponent={subHeaderComponent}
                      noDataComponent={<b style={{padding:10}}>No hay listas de asistencia</b>}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>

          <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>{isEditingAssist ? 'Editar Asistencia' : 'Nueva Lista de Asistencia' }
            <button className="btn-close invisible" type="button">
              <span aria-hidden="true" className="visible" onClick={toggle}></span>
            </button>
          </ModalHeader>
          <ModalBody>
            {/* Resumen de ausencias reportadas por padres */}
            {dataStudents && dataStudents.length > 0 && (
              (() => {
                const reportedAbsences = dataStudents.filter(student => student.reportedByParent && !student.assist);
                if (reportedAbsences.length > 0) {
                  return (
                    <div className="alert alert-info mb-3" role="alert">
                      <div className="d-flex align-items-center">
                        <i className="fa fa-info-circle me-2"></i>
                        <div>
                          <strong>Ausencias reportadas por padres:</strong> {reportedAbsences.length} estudiante(s)
                          <br />
                          <small>Estos estudiantes aparecerán marcados como ausentes con el motivo reportado por sus padres.</small>
                        </div>
                      </div>
                    </div>
                  );
                }
                return null;
              })()
            )}
            <div className="container">
              <Form className="needs-validation" noValidate="" onSubmit={handleSubmit( isEditingAssist ? patchHomework : saveAssist)} style={{padding:20}}>
                <Row className="g-3 dflex mb-3">
                  <Col md="12">
                    <Label className="form-label font-weight-bold">
                      Grado
                    </Label>
                    {isEditingAssist ?
                      <h4>{gradeSelected[0].name}</h4>
                    :
                    <Typeahead
                      id="gradeFinder"
                      clearButton
                      defaultSelected={gradeSelected}
                      labelKey="name"
                      options={dataGrades}
                      placeholder="Buscar Grupo de Alumnos..."
                      onChange={(e)=>{handleGradeSelection(e)}}
                    /> }
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-3">
                  <Col md="12">
                    <Label className="form-label font-weight-bold" for="validTitle">
                      Fecha Lista
                    </Label>
                    <DatePicker className="form-control digits"
                        selected={date}
                        onChange={handleChangeStart}
                        selectsStart
                        minDate={new Date()}
                        disabled={true}
                        locale={es}
                        dateFormat={'dd/MM/yyyy'}
                      />
                  </Col>
                </Row>
                {
                  dataStudents.length > 0 ?
                    <div className="container mt-3 p-3" style={{background: '#f4f4f4', borderRadius: 10}}>
                    <Row className="mb-2">
                      <Col sm="9">
                        <h6 className="font-weight-bold">Alumno(a)</h6>
                      </Col>
                      <Col sm="3">
                        <h6 className="font-weight-bold">Asistencia</h6>
                      </Col>
                    </Row>
                      {
                        dataStudents.map(student=>{
                          return(
                                <Row key={student.uuid}>
                                  <Col sm="9" className="mb-2">
                                    <h6>{student.name}</h6>
                                    {student.reportedByParent && !student.assist && (
                                      <div className="mt-1">
                                        <small className="text-info">
                                          <i className="fa fa-exclamation-triangle me-1"></i>
                                          <strong>Reportado por padre:</strong> {student.absenceReason}
                                        </small>
                                      </div>
                                    )}
                                  </Col>
                                  <Col sm="3" className="text-center mb-2">
                                    <input 
                                      size={30} 
                                      type="checkbox" 
                                      checked={student.assist} 
                                      onChange={(e)=>handleAssistChange(e.target.checked,student.uuid)}
                                      disabled={student.reportedByParent && !student.assist}
                                    />
                                    {student.reportedByParent && !student.assist && (
                                      <div className="mt-1">
                                        <small className="text-muted">
                                          <i className="fa fa-lock me-1"></i>
                                          Bloqueado
                                        </small>
                                      </div>
                                    )}
                                  </Col>
                                </Row>
                          )
                        })
                      }
                    </div>
                  : null
                }
                <Row style={{display:'flex', justifyContent:'end', paddingTop:20}}>
                {
                  isEditingAssist ? 
                    <Button disabled={patchingHomework} className="btn btn-primary" style={{width:150}} color="primary">{"Guardar"}</Button> 
                  : 
                    <Button disabled={savingAssist} className="btn btn-primary" style={{width:150}} color="primary">{"Guardar"}</Button> 
                }
                </Row>
              </Form>
            </div>
          </ModalBody>
        </Modal>

        </>
      : null }
    </Fragment>
  );
};

export default Assists;
